export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text)
    return true
  } catch (e) {
    console.error(e)
  }
  try {
    const input = document.createElement('input')
    input.value = text
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    return true
  } catch (e) {
    console.error(e)
  }
  return false
}

export async function copyImage(url: string, element: HTMLElement | null | undefined): Promise<void> {
  try {
    const response = await fetch(url)
    const blob = await response.blob()
    const type = 'image/png'
    const image = new Blob([blob], { type })
    await navigator.clipboard.write([new ClipboardItem({ [type]: image })])
    return
  } catch (e) {
    console.error(e)
  }
  copyText(url)
}
